var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFroth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 110 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2a559a;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 23.26,
    y1: 41.03,
    x2: 4.95,
    y2: 5.2,
    gradientTransform: "translate(0 42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#558ce4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2a559a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#558ce4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.5,15.2v1.19h-4.96v2.67h4.29v1.18h-4.29v3.95h-1.34v-8.99h6.3Zm10.39,0c.99,0,1.79.28,2.41.83.62.55.93,1.27.93,2.15,0,.64-.19,1.19-.56,1.67-.37.47-.87.81-1.5,1.02l2.35,3.33h-1.66l-2.01-3.01h-2.45v3.01h-1.38v-8.99h3.87Zm-2.49,4.81h2.34c.65,0,1.16-.16,1.54-.49.38-.33.57-.78.57-1.34s-.18-1.02-.55-1.33c-.37-.31-.87-.47-1.5-.47h-2.4v3.63Zm16.68-5c.69,0,1.33.12,1.92.36.59.24,1.09.57,1.5.98.41.42.72.91.95,1.49.23.58.35,1.2.35,1.86,0,.86-.2,1.64-.59,2.35-.39.71-.94,1.27-1.67,1.7-.72.42-1.54.64-2.46.64-.69,0-1.33-.12-1.92-.37-.59-.24-1.09-.58-1.49-1-.41-.42-.72-.92-.96-1.49-.23-.58-.34-1.19-.34-1.84,0-.86.2-1.65.59-2.36.4-.71.96-1.28,1.68-1.7.72-.42,1.54-.63,2.44-.63Zm0,1.19c-.68,0-1.28.16-1.8.47-.51.31-.9.73-1.16,1.25s-.39,1.12-.39,1.78.13,1.25.4,1.78c.27.52.65.94,1.16,1.25.51.31,1.11.46,1.79.46s1.28-.15,1.8-.45c.51-.31.9-.72,1.16-1.25.27-.52.4-1.12.4-1.79s-.14-1.28-.41-1.8c-.27-.52-.66-.94-1.17-1.24-.51-.3-1.11-.45-1.79-.45Zm18.31-1v1.21h-3.3v7.79h-1.35v-7.79h-3.3v-1.21h7.95Zm7.83,0v3.78h4.82v-3.78h1.37v8.99h-1.37v-3.99h-4.82v3.99h-1.38v-8.99h1.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m8.86,13.36v21.24l4.04-2.65v-5.31l8.02-5.31v-5.31l-8.02,5.31v-5.31l8.02-5.31v-5.31l-12.06,7.96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFroth);
export default __webpack_public_path__ + "static/media/froth.6dfd0b6bd137345512c9cebbf411703f.svg";
export { ForwardRef as ReactComponent };